// src/api/userApi.ts

import { AxiosApi } from "..";
import { axiosInstance } from "../axiosInstance";
import type { MenuItem } from "src/types/menu/menuTypes";

export const userApi = {
  getMyInfo() {
    return AxiosApi.get("/users/me");
  },

  updateProfile(data: any) {
    return AxiosApi.put("/users/me", data);
  },

  deleteUser() {
    return AxiosApi.delete("/users/me");
  },
};

// src/api/auth/authApi.ts
export type GoogleTokenResult = {
  accessToken: string;
  refreshToken: string;
  userId: string;
  name: string;
  email: string;
  menuTree?: MenuItem[];
};

export type DelegateLoginResult = {
  tokenType: string;
  accessToken: string;
  refreshToken: string;
  userId: number;
  name: string;
  email: string;
  menuTree?: MenuItem[];
};

type ApiResponse<T> = {
  statusCode?: number;
  message?: string;
  data: T;
};

export async function exchangeGoogleCodeApi(code: string): Promise<GoogleTokenResult> {
  console.log("exchange code to token entry:", code);
  const res = await fetch(`${process.env.REACT_APP_OMS_SERVER_API}/v1/admin/auth/google/token`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ code }),
  });

  if (!res.ok) throw new Error("토큰 교환 실패");

  const json: ApiResponse<GoogleTokenResult> = await res.json();

  // statusCode 규격이 있으면 체크
  if (typeof json.statusCode === "number" && json.statusCode !== 0) {
    throw new Error(json.message || "토큰 교환 실패");
  }

  return json.data;
}

export async function logoutApi(): Promise<void> {
  // 서버에서 refreshToken을 쿠키에서 꺼내서 무효화/블랙리스트 처리한다고 가정
  await axiosInstance.post("/v1/admin/auth/logout", null, {
    snackbar: { success: false, error: false },
  });
}

// 입점사 로그아웃
export async function delegateLogoutApi(): Promise<void> {
  await axiosInstance.post("/v1/delegate/auth/logout", null, {
    snackbar: { success: false, error: false },
  });
}

// 입점사 로그인 (이메일/비밀번호)
export async function delegateLoginApi(
  email: string,
  password: string
): Promise<DelegateLoginResult> {
  const res = await fetch(`${process.env.REACT_APP_OMS_SERVER_API}/v1/delegate/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ email, password }),
  });

  if (!res.ok) throw new Error("로그인 실패");

  const json: ApiResponse<DelegateLoginResult> = await res.json();

  if (typeof json.statusCode === "number" && json.statusCode !== 1) {
    throw new Error(json.message || "로그인 실패");
  }

  return json.data;
}
